import { render, staticRenderFns } from "./AddTeamMember.vue?vue&type=template&id=474705b2"
import script from "./AddTeamMember.vue?vue&type=script&lang=js"
export * from "./AddTeamMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports